<script lang="ts">
	import type { DoubleColumnContent } from '../types';

	export let text: string | DoubleColumnContent;
</script>

<div
	class="flex flex-col md:flex-row gap-6 content-module-padding wysisyg-content text-quaternary lg:pl-9"
	{...$$restProps}
>
	{#if typeof text === 'string'}
		<div>
			<!-- eslint-disable -->
			{@html text}
		</div>
	{:else if Array.isArray(text) && text.length > 0}
		{#each text as paragraph, i}
			<div class="flex-1">
				<!-- eslint-disable -->
				{@html text[i].content}
			</div>
		{/each}
	{/if}
</div>
